"use strict";
/**
 * Copyright © 2019 Johnson & Johnson
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withTitle = exports.withMetaStatic = exports.withMetaHtml = exports.withMeta = exports.withHeadElement = void 0;

var react_1 = __importDefault(require("react"));

var core_1 = require("@bodiless/core");

var lodash_1 = require("lodash");

var withMetaForm_1 = require("./withMetaForm");

var withTitle$ = function withTitle$() {
  return function (HelmetComponent) {
    return function (_a) {
      var children = _a.children,
          content = _a.content,
          rest = __rest(_a, ["children", "content"]);

      return react_1.default.createElement(HelmetComponent, __assign({}, rest), children, content && react_1.default.createElement("title", null, content));
    };
  };
};

var withMeta$ = function withMeta$(options) {
  return function (HelmetComponent) {
    return function (_a) {
      var _b;

      var children = _a.children,
          content = _a.content,
          rest = __rest(_a, ["children", "content"]);

      var attributes = (_b = {}, _b[options.attribute ? options.attribute : 'name'] = options.name, _b);
      return react_1.default.createElement(HelmetComponent, __assign({}, rest), children, content && react_1.default.createElement("meta", __assign({}, attributes, {
        content: content
      })));
    };
  };
}; // @todo withHeadElement to its own file.


exports.withHeadElement = function (renderHoc) {
  return function (options) {
    return function (nodeKey, defaultContent) {
      return core_1.withSidecarNodes(core_1.withNodeKey(nodeKey), core_1.withNode, core_1.withNodeDataHandlers({
        content: defaultContent
      }), core_1.ifEditable(withMetaForm_1.withMetaSnippet(__assign({}, options))), core_1.withoutProps('setComponentData'), core_1.withData, renderHoc(options));
    };
  };
};

var withMeta = exports.withHeadElement(withMeta$);
exports.withMeta = withMeta;
var withTitle = exports.withHeadElement(withTitle$);
exports.withTitle = withTitle;

var withMetaStatic = function withMetaStatic(options) {
  return function (nodeKey, defaultContent) {
    return lodash_1.flowRight(core_1.asReadOnly, // @ts-ignore: non-editable meta data pass in BasicOptions.
    withMeta(options)(nodeKey, defaultContent));
  };
};

exports.withMetaStatic = withMetaStatic;

var withMetaHtml = function withMetaHtml(lang, nodeKey, nodeCollection) {
  return function (HelmetComponent) {
    return function (props) {
      var children = props.children,
          rest = __rest(props, ["children"]);

      var node = core_1.useNode(nodeCollection).node;
      var childNode = node.child(nodeKey);
      return react_1.default.createElement(HelmetComponent, __assign({}, rest), children, react_1.default.createElement("html", __assign({
        lang: lang
      }, childNode.data)));
    };
  };
};

exports.withMetaHtml = withMetaHtml;